export default {
  // Page Header
  page_header: {
    title: "Your Channels",
    description: "In this page you can find information about Lab Portal.",
    action_buttons: {
      refresh: {
        label: "Refresh Channels",
        tooltip: "Refresh the list of channels",
      },
    },
  },

  // Content
  channel_card: {
    action_buttons: {
      start: "Start",
      stop: "Stop",
    },
  },
  channel: "channel",
  channels: "channels",
  online: "Online",
  offline: "Offline",
  connected: "Connected",
  not_connected: "Not Connected",
  instrument_name: "Instrument Name",
  driver_id: "Driver ID",
  port: "Port",

  // Empty State
  no_channels_title: "No Channels Available",
  no_channels_description:
    "There are currently no channels configured. Please check your connection or refresh.",
  refresh_channels: "Refresh Channels",
};
